import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=706fec0e&"
import script from "./checkDetail.vue?vue&type=script&lang=js&"
export * from "./checkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports